/* global Sentry */
export default (store) => (next) => (action) => {
    try {
        return next(action);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Exception in a reducer!', error);
        if ('Sentry' in window) {
            Sentry.withScope((scope) => {
                scope.setExtras({
                    action,
                    state: store.getState(),
                });

                Sentry.captureException(error);
            });
        }
    }
};
